import { Button, Modal } from "@cividao/components"
import { useLogos } from "../../../hooks/useLogos"
import styles from "./index.module.css"

interface LogoutModalProps {
  onClose: () => void
  title: string
  message: string
  email: string
  confirmText: string
  cancelText: string
  showLogo?: boolean
  warning?: string
  alternative?: string
}

export function LogoutModal({
  onClose,
  title,
  message,
  email,
  confirmText,
  cancelText,
  showLogo = true,
  warning,
  alternative,
}: LogoutModalProps) {
  const { logo } = useLogos()

  const handleConfirm = async () => {
    try {
      await window.domain.LogoutAuthUseCase.execute()
      window.location.href = "/"
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal onClose={onClose} title={title} size="s">
      <div className={styles.container}>
        {showLogo && (
          <div className={styles.header}>
            <img src={logo} alt="" className={styles.logo} />
          </div>
        )}
        <div className={styles.message}>
          <p>{message}</p>
          <p className={styles.email}>{email}</p>
          {warning && <p>{warning}</p>}
        </div>
        {alternative && <p className={styles.alternative}>{alternative}</p>}
        <div className={styles.actions}>
          <Button isFull onClick={handleConfirm}>
            {confirmText}
          </Button>
          <Button isFull type="outline" onClick={onClose}>
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
